import React from 'react';
import Grid from '@material-ui/core/Grid';
import MDXParser from '../mdxParser';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Img from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';

// Content
import Foreword from '../../sections/Foreword/Foreword';
import ForewordRight from '../../sections/Foreword/ForewordRight';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      padding: '0px 0px 10px 0px',
      color: '#0076bb',
      borderBottom: '2px solid #0076bb'
    },
    container: {
      padding: '30px 0',
    },
  }),
);

type Props = { children: React.ReactNode; image: string };

const ForewordSection = () => {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query {
      fatou: file(relativePath: { eq: "fatou.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Grid container spacing={3} className={classes.container}>
      <Grid item xs={12} md={12}>
        <MDXParser>
          <Typography variant="h1" gutterBottom={false} className={classes.title}>
            FOREWORD
          </Typography>
        </MDXParser>
      </Grid>

      <Grid item xs={12} md={6}  >
        <MDXParser>
          <Foreword />
        </MDXParser>
      </Grid>

      <Grid item xs={12} md={6}>
        <MDXParser>
          <ForewordRight />
        </MDXParser>
      </Grid>
    </Grid>
  );
};

export default ForewordSection;
